import { sortBy, takeRight } from 'lodash'
import { useState } from 'react'

import LinkText from '@/components/LinkText/LinkText'
import Tag from '@/components/Tag/Tag'
import Tooltip from '@/components/Tooltip/Tooltip'
import TruncateElementsList from '@/components/common/TruncateElementsList'
import useAuthStore from '@/store/useAuthStore'
import type { StudentClass } from '@/types/class'

import styles from './ClassesColumn.module.scss'

type ClassesColumnProps = {
  studentClasses: StudentClass[]
}

const ClassesColumn = (props: ClassesColumnProps) => {
  const { user: userStore } = useAuthStore()

  const [isExpandedClasses, setIsExpandedClasses] = useState(false)

  const tutorClassesIds =
    userStore?.tutorClasses?.map(tutorClass => tutorClass.id) || []

  const myClasses = sortBy(
    props.studentClasses.filter(
      studentClass =>
        studentClass.id && tutorClassesIds.includes(studentClass.id)
    ),
    'name'
  )

  const otherClasses = sortBy(
    props.studentClasses.filter(
      studentClass =>
        (studentClass.id && !tutorClassesIds.includes(studentClass.id)) ||
        !studentClass.id
    ),
    'name'
  )

  const classesList = [...myClasses, ...otherClasses]
  const classesNamesList = classesList.map(studentClass => studentClass.name)

  return (
    <TruncateElementsList
      expanded={isExpandedClasses}
      onExpandedChange={setIsExpandedClasses}
      elipsis={hiddenItemsCount => (
        <Tooltip
          text={takeRight(classesNamesList, hiddenItemsCount).join(', ')}
          trigger={
            <Tag
              color="white"
              variant="with-background"
              label={`+${hiddenItemsCount}`}
              onClick={() => {
                setIsExpandedClasses(true)
              }}
            />
          }
        />
      )}
    >
      {classesList.map((studentClass, index) =>
        studentClass.id ? (
          <LinkText
            key={index}
            className={styles.classElement}
            to="/students-and-classes/classes/$classId/details"
            params={{
              classId: studentClass.id
            }}
            truncateElement
          >
            {studentClass.name}
          </LinkText>
        ) : (
          <p key={index} className={styles.classElement}>
            {studentClass.name}
          </p>
        )
      )}
    </TruncateElementsList>
  )
}

export default ClassesColumn
